import logo from "./images/logo/VKN-logo.png";
import giftcardImg from "./images/win-win-win.png";
import "./App.css";
import { useState } from "react";
import axios from "axios";
import actievoorwaardenPdf from "./downloads/Actievoorwaarden-VKN.pdf";

// ✅ Video import
import heroVideo from "./video/video-v4.mp4";

function App() {
  const [selectedUrl, setSelectedUrl] = useState("https://schaatsbaanrotterdam.nl");

  const [newsletterData, setNewsletterData] = useState({
    voornaam: "",
    achternaam: "",
    email: "",
    woonplaats: "",
    favorieteIjsbaan: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewsletterData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      Emailadres: newsletterData.email,
      Achternaam: newsletterData.achternaam,
      Voornaam: newsletterData.voornaam,
      Woonplaats: newsletterData.woonplaats,
      FavorieteIJsbaan: newsletterData.favorieteIjsbaan,
    };

    const token = process.env.REACT_APP_CM_TOKEN;

    axios
      .post(
        "https://api.cdp.cm.com/events/v1.0/tenants/adf4c185-7e43-4a27-9d6a-3677f2dde26e/events/0db6941e-7469-5f09-8300-a3473e954451",
        JSON.stringify(data),
        {
          headers: {
            "X-CM-PRODUCTTOKEN": token,
            "Content-Type": "application/json",
          },
        }
      )
      .then(() => setIsSubmitted(true))
      .catch((err) => console.log(err));
  };

  const handleSearch = () => {
    if (!selectedUrl) return;
    window.open(selectedUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="container-fluid p-0">
      {/* HERO */}
      <div className="full-background">
        {/* ✅ Video background */}
        <video
          className="hero-video"
          src={heroVideo}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        />

        {/* ✅ Optional overlay for readability */}
        <div className="hero-overlay" />

        <img className="full-logo" src={logo} alt="VKN" />

        <div className="hero-content">
          <p className="header-text">VIND HOLLANDS IJS BIJ JOU IN DE BUURT!</p>

          <div className="search-ijsbaan">
            <span className="label-search-ijsbaan">zoek ijsbaan</span>

            <select
              className="select-ijsbaan"
              aria-label="Selecteer je stad"
              value={selectedUrl}
              onChange={(e) => setSelectedUrl(e.target.value)}
            >
              <option value="https://schaatsbaanrotterdam.nl">Schaatsbaan Rotterdam</option>
              <option value="https://deuithof.nl">De Uithof, Den Haag</option>
              <option value="https://www.ijshaldevliet.nl">IJshal de Vliet, Leiden</option>
              <option value="https://www.silverdome.nl">Silverdome, Zoetermeer</option>
              <option value="https://www.optisport.nl/sportboulevard-dordrecht">Sportboulevard, Dordrecht</option>
              <option value="https://www.laco.eu/overige-activiteiten/schaatsen/">
                Sportpark Glanerbrook, Geleen
              </option>
              <option value="https://sport050.nl/sportlocaties/intern/sportcentrum-kardinge/activiteiten/recreatief-schaatsen">Kunstijsbaan Kardinge, Groningen</option>
              <option value="https://thialf.nl/">Thialf, Heerenveen</option>
              <option value="https://triavium.nl/">Triavium, Nijmegen</option>
              <option value="https://ijsbaanhaarlem.nl/language/nl/home-ijsbaan-haarlem/">IJsbaan Haarlem</option>
              <option value="https://elfstedenhal.nl">De Elfstedenhal, Leeuwarden</option>
              <option value="https://sportiom.sportfondsen.nl/activiteiten/schaatsen/">Sportiom, ’s-Hertogenbosch</option>
              <option value="https://ijssportcentrumeindhoven.sportfondsen.nl/">IJssportcentrum Eindhoven</option>
              <option value="https://sportbedrijfdeventer.nl/descheg/ijsbaan/">De Scheg, Deventer</option>
              <option value="https://www.optisport.nl/kunstijsbaan-breda">Kunstijsbaan Breda</option>
              <option value="https://www.sportintilburg.nl/sport-en-bewegen/schaatsen/ireen-wust-ijsbaan/">Ireen Wüst IJsbaan, Tilburg</option>
              <option value="https://www.optisport.nl/schaatsbaan-twente">IJsbaan Twente, Enschede</option>
              <option value="https://vechtsebanen.nl/">Vechtsebanen, Utrecht</option>
              <option value="https://www.demeentalkmaar.nl/">Kunstijsbaan de Meent, Alkmaar</option>
              <option value="https://www.jaapeden.nl">Jaap Eden IJsbaan, Amsterdam</option>
              <option value="https://www.optisport.nl/schaatsbaan-de-westfries-hoorn">IJsbaan De Westfries, Hoorn</option>
            </select>

            <button onClick={handleSearch} className="btn-search" type="button">
              Ga naar website{" "}
              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6 18.5L12.9269 12.8628C14.3577 11.708 14.3577 9.29202 12.9269 8.13723L6 2.5"
                  stroke="#294C49"
                  strokeWidth="2.5"
                  strokeMiterlimit="10"
                />
              </svg>
            </button>
          </div>
        </div>

        <button className="video-cta" type="button" aria-label="Bekijk film">
          <span className="video-cta__circle">
            <svg className="video-cta__icon" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M9 7.5V16.5L16.5 12L9 7.5Z" fill="#294C49" />
            </svg>
          </span>
          <span className="video-cta__label">bekijk film</span>
        </button>
      </div>

      {/* BODY */}
      <div className="body-container">
        <div className="body-grid">
          <section className="card-base card--action">
            <div className="action-top">
              <img className="action-img" src={giftcardImg} alt="Schaats cadeaukaart" />
            </div>

            <div className="action-body">
              <p className="action-title">Maak kans op één van de 100 Schaats Cadeaukaarten ter waarde van €20!</p>

              <p className="action-text">
                Met deze cadeaukaart schaats je bij alle VKN-ijsbanen in Nederland. Meedoen is simpel: vul het formulier
                in en wie weet sta jij binnenkort op het ijs. Op 1 februari maken we de winnaars bekend.
              </p>

              <div className="action-buttons">
                <a href="https://www.kunstijsbanen.nl/cadeaukaart">
                  <button className="btn-secondary" type="button">
                    Meer informatie
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6 18.5L12.9269 12.8628C14.3577 11.708 14.3577 9.29202 12.9269 8.13723L6 2.5"
                        stroke="#294C49"
                        strokeWidth="2.5"
                        strokeMiterlimit="10"
                      />
                    </svg>
                  </button>
                </a>

                <a href={actievoorwaardenPdf} download className="btn-tertiary">
                  Actievoorwaarden
                  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6 18.5L12.9269 12.8628C14.3577 11.708 14.3577 9.29202 12.9269 8.13723L6 2.5"
                      stroke="#fff"
                      strokeWidth="2.5"
                      strokeMiterlimit="10"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </section>

          <section className="card-base card--form">
            <h2 className="form-title">DEELNAME FORMULIER</h2>

            <form onSubmit={handleSubmit} className="form">
              <div className="form-row">
                <div className="field">
                  <label>Voornaam</label>
                  <input
                    type="text"
                    name="voornaam"
                    placeholder="Voornaam"
                    value={newsletterData.voornaam}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="field">
                  <label>Achternaam</label>
                  <input
                    type="text"
                    name="achternaam"
                    placeholder="Achternaam"
                    value={newsletterData.achternaam}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="field">
                <label>E-mailadres</label>
                <input
                  type="email"
                  name="email"
                  placeholder="E-mailadres"
                  value={newsletterData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="field">
                <label>Woonplaats</label>
                <input
                  type="text"
                  name="woonplaats"
                  placeholder="Woonplaats"
                  value={newsletterData.woonplaats}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="field">
                <label>Favoriete ijsbaan</label>
                <select
                  name="favorieteIjsbaan"
                  className="favorite-ijsbaan"
                  aria-label="Selecteer je favoriete ijsbaan"
                  value={newsletterData.favorieteIjsbaan}
                  onChange={handleInputChange}
                  required
                >
                  <option value="" disabled>
                    Kies je favoriete ijsbaan…
                  </option>
                  <option value="Schaatsbaan Rotterdam">Schaatsbaan Rotterdam</option>
                  <option value="De Uithof, Den Haag">De Uithof, Den Haag</option>
                  <option value="Laco Sport- en Recreatiecentrum Glanerbrook, Geleen">
                    Sportpark Glanerbrook, Geleen
                  </option>
                  <option value="Kunstijsbaan Kardinge, Groningen">Kunstijsbaan Kardinge, Groningen</option>
                  <option value="IJsbaan Haarlem, Haarlem">IJsbaan Haarlem, Haarlem</option>
                  <option value="De Elfstedenhal, Leeuwarden">De Elfstedenhal, Leeuwarden</option>
                  <option value="Sportiom, ’s-Hertogenbosch">Sportiom, ’s-Hertogenbosch</option>
                  <option value="IJsbaan De Westfries, Hoorn">IJsbaan De Westfries, Hoorn</option>
                  <option value="IJshal de Vliet, Leiden">IJshal de Vliet, Leiden</option>
                  <option value="IJssportcentrum Eindhoven">IJssportcentrum Eindhoven</option>
                  <option value="De Scheg, Deventer">De Scheg, Deventer</option>
                  <option value="Kunstijsbaan Breda">Kunstijsbaan Breda</option>
                  <option value="Silverdome, Zoetermeer">Silverdome, Zoetermeer</option>
                  <option value="Triavium, Nijmegen">Triavium, Nijmegen</option>
                  <option value="Thialf, Heerenveen">Thialf, Heerenveen</option>
                  <option value="IJsbaan Twente, Enschede">IJsbaan Twente, Enschede</option>
                  <option value="Vechtsebanen, Utrecht">Vechtsebanen, Utrecht</option>
                  <option value="Sportboulevard, Dordrecht">Sportboulevard, Dordrecht</option>
                  <option value="Jaap Edenbaan, Amsterdam">Jaap Edenbaan, Amsterdam</option>
                  <option value="Kunstijsbaan de Meent, Alkmaar">Kunstijsbaan de Meent, Alkmaar</option>
                  <option value="Ireen Wüst IJsbaan, Tilburg">Ireen Wüst IJsbaan, Tilburg</option>
                </select>
              </div>

              <div className="field field--checkbox">
                <label>Privacy & toestemming</label>
                <p className="privacy-info">
                  Door deel te nemen aan deze actie ga je ermee akkoord dat de door jou ingevulde persoonsgegevens worden
                  verwerkt door de Vereniging van Kunstijsbanen Nederland (VKN). Deze gegevens worden gebruikt voor het
                  afhandelen van de winactie én voor marketing- en communicatiedoeleinden van VKN en aangesloten
                  ijsbanen, zoals het ontvangen van nieuws, aanbiedingen en acties. Je kunt je op ieder moment afmelden
                  via de afmeldlink in de communicatie. Meer informatie over hoe wij met persoonsgegevens omgaan, vind
                  je in onze privacyverklaring.
                </p>

                <label className="checkbox-row">
                  <input className="checkbox-input" type="checkbox" name="privacy" required />
                  <span className="checkbox-text">
                    Ik geef toestemming voor het ontvangen van marketingcommunicatie van VKN en aangesloten ijsbanen.
                  </span>
                </label>
              </div>

              {isSubmitted ? (
                <div className="newsletter-input-box">
                  <p className="newsletter-success-message">Bedankt voor je deelname!</p>
                </div>
              ) : (
                <div className="form-actions">
                  <button className="btn-primary" type="submit">
                    Deelname versturen
                  </button>
                </div>
              )}
            </form>
          </section>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="vkn-footer">
        <div className="vkn-footer__inner">
          <div className="vkn-footer__grid">
            <div className="vkn-footer__logo">
              <img src={logo} alt="VKN" />
            </div>

            <div className="vkn-footer__col">
              <h4>VKN</h4>
              <ul>
                <li><a href="https://www.kunstijsbanen.nl/over-ons" rel="noreferrer">Over ons</a></li>
                <li><a href="https://www.kunstijsbanen.nl/nieuws" rel="noreferrer">Nieuws</a></li>
                <li><a href="https://www.kunstijsbanen.nl/leden" rel="noreferrer">Informatie leden</a></li>
                <li><a href="https://www.kunstijsbanen.nl/businessleden" rel="noreferrer">Informatie business leden</a></li>
                <li><a href="https://www.kunstijsbanen.nl/vkn-lidmaatschap" rel="noreferrer">Direct aanmelden</a></li>
              </ul>
            </div>

            <div className="vkn-footer__col">
              <h4>Kunstijsbanen</h4>
              <p className="vkn-footer__muted">Overzicht ijsbanen in Nederland</p>

              <a className="vkn-footer__btn" href="https://www.kunstijsbanen.nl/cadeaukaart" rel="noreferrer">
                Cadeaukaart
              </a>
            </div>

            <div className="vkn-footer__col">
              <h4>Adres</h4>
              <div className="vkn-footer__text">
                <div>Vereniging Kunstijsbanen Nederland</div>
                <div>p/a Radioweg 64</div>
                <div>1098 NJ, Amsterdam</div>
              </div>

              <a
                className="vkn-footer__route"
                href="https://www.google.com/maps/search/?api=1&query=Radioweg+64+1098+NJ+Amsterdam"
                target="_blank"
                rel="noopener noreferrer"
              >
                Bereken route <span aria-hidden="true">›</span>
              </a>
            </div>

            <div className="vkn-footer__col">
              <h4>Contact</h4>
              <div className="vkn-footer__text">
                <div><a href="tel:0852016808">085 – 201 6808</a></div>
                <div><a href="mailto:secretariaat@kunstijsbanen.nl">secretariaat@kunstijsbanen.nl</a></div>
              </div>
            </div>
          </div>

          <div className="vkn-footer__bottom">
            <div className="vkn-footer__bottomLeft">
              <a href="https://www.kunstijsbanen.nl/algemene-voorwaarden" rel="noreferrer">Algemene voorwaarden</a>
              <a href="https://www.kunstijsbanen.nl/privacy" rel="noreferrer">Privacy</a>
              <a href="https://www.kunstijsbanen.nl/disclaimer" rel="noreferrer">Disclaimer</a>
              <span>© 2026 VKN</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;